<template>
  <div class="highcharts" />
</template>

<script>
import Highcharts from "highcharts";

export default {  
  name: "VueHighcharts",
  props: ["options", "Highcharts"],
  data() {
    return {
      chart: null
    };
  },
  watch: {
    options: function(options) {
      if (options) {
        this.init();
      } else {
        this.chart.update(this.options);
      }
    }
  },
  mounted() {
    if (this.options) {
      this.init();
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    addSeries(options) {
      this.delegateMethod("addSeries", options);
    },
    mergeOption(options) {
      this.delegateMethod("update", options);
    },
    showLoading(txt) {
      this.chart.showLoading(txt);
    },
    hideLoading() {
      this.chart.hideLoading();
    },
    delegateMethod(name, ...args) {
      if (!this.chart) {
        console.log(
          `Cannot call [$name] before the chart is initialized. Set prop [options] first.`,
          this
        );
        return;
      }
      return this.chart[name](...args);
    },
    init() {
      if (this.options) {
        let _Highcharts = this.Highcharts || Highcharts;
        this.chart = new _Highcharts.Chart(this.$el, this.options);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/vueHighcharts.vue